'use client';

import { globalizationService } from '../../../services/globalizationService';
import { DefaultHeader } from './EpStarterDefaultHeader';
import { InternalHeader } from './EpStarterInternalHeader';
import { LoggedOutHeader } from './EpStarterLoggedOutHeader';

/**
 * Header used in EpStarter template
 */

interface IStarterHeaderProps {
  template?: 'default' | 'internal' | 'logged-out';
  translations?: unknown;
}

/**
 * @TODO - Mudar o import das imagens da pasta 'public' para o CDN quando disponível
 * @TODO - Rever o header logado quando vier a correção da lib
 * @TODO - Falta botão de procurar e a imagem do hospital epimed entre o avatar
 * @TODO - Falta link redirect para o hospital
 */

export const StarterHeader = ({
  template = 'default',
}: IStarterHeaderProps) => {
  const {
    translations: cultures,
  } = globalizationService.getCultures();

  const headerTemplate = {
    default: <DefaultHeader cultures={cultures} />,
    internal: <InternalHeader cultures={cultures} />,
    'logged-out': <LoggedOutHeader cultures={cultures} />,
  };

  return <>{headerTemplate[template]}</>;
};
